import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";

import Actions from "../../../../../store/actions/customerActions";
import {handle} from "./../../../../../common/responseHandler";
import Loader from "../../../../Common/Loader";
import NotFound from "../../../../Common/NotFound";
import Order from "./Order";

function Orders({customer}) {
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.loader);

    useEffect(() => {
        if (customer.uuid && !customer.hasOrdersLoaded && !customer.votOrderIdLoaded && !customer.hasOrdersFailed) {
            dispatch(Actions.getOrders(customer.uuid, customer.brand)).catch(handle);
            dispatch(Actions.getShowVOTOrderId(customer.uuid, customer.locale, customer.brand)).catch(handle);
        }
    }, [customer.hasOrdersFailed, customer.votOrderIdLoaded, customer.locale, customer.brand,
        customer.hasOrdersLoaded, customer.uuid, dispatch]);

    const loaded = _.get(customer, `votOrderIdLoaded`) && _.get(customer, `hasOrdersLoaded`)
        || (_.get(customer, `hasOrdersFailed`) && !isLoading);

    return loaded ?
        <>
            <div className="row equal-height">
                {_.some(customer.orders) && Array.isArray(customer.orders) ? (
                    customer.orders.map(order => <div className="col-xs-12" key={order.id}>
                        <Order customer={customer} order={order} showOrderId={_.get(customer, `showVOTOrderId`)}/>
                    </div>)
                ) : (
                    <NotFound>No VOT orders found for this customer...</NotFound>
                )}
            </div>
        </> : <Loader relative/>;
}

Orders.propTypes = {
    customer: PropTypes.object.isRequired
};
export default Orders;
